import { TristateSwitch, TristateSwitchProps } from './TristateSwitch';

export interface BinarySwitchProps
    extends Omit<TristateSwitchProps, 'value' | 'onChange' | 'disableNull'> {
    value: boolean;
    onChange: (value: boolean) => void;
    asToggleButton?: boolean;
}

export const BinarySwitch = ({
    value,
    onChange,
    asToggleButton = true,
    ...props
}: BinarySwitchProps) => {
    const handleChange = (newValue: boolean | null) => {
        if (asToggleButton) {
            // Always toggle regardless of which button was clicked
            onChange(!value);
        } else {
            // Normal behavior - use the specific value
            onChange(newValue === true);
        }
    };

    return (
        <TristateSwitch
            {...props}
            value={value}
            onChange={handleChange}
            disableNull={true}
        />
    );
};
